import React from 'react';
import { Asset } from 'expo-asset';
import useSceneActivity from './useSceneActivity.web';

const scene = Asset.fromModule(require('@/assets/images/landing-footer-pixel.webp')).uri;

const coverStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'right center',
  imageRendering: 'pixelated',
  pointerEvents: 'none',
};

function FooterPixelScene() {
  const activityRef = useSceneActivity();
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <img src={scene} alt="" aria-hidden="true" loading="lazy" decoding="async" style={coverStyle} />
      <svg ref={activityRef} data-scene-active="false" data-pixel-scene="true" aria-hidden="true" focusable="false" viewBox="0 0 1672 941" preserveAspectRatio="xMaxYMid slice" style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'hidden', pointerEvents: 'none' }}>
        <defs>
          <radialGradient id="footer-lantern-glow">
            <stop offset="0" stopColor="#ffbd57" stopOpacity=".4" />
            <stop offset="1" stopColor="#ffbd57" stopOpacity="0" />
          </radialGradient>
        </defs>
        <g data-pixel-lantern="true">
          <circle cx="1238" cy="516" r="80" fill="url(#footer-lantern-glow)" />
          <circle cx="1478" cy="261" r="55" fill="url(#footer-lantern-glow)" />
        </g>
        <g shapeRendering="crispEdges">
          {[[145, 55], [600, 117], [909, 90], [775, 118], [981, 118], [1157, 144], [749, 72], [252, 208]].map(([x, y], i) => (
            <rect key={i} data-pixel-star="true" x={x - 2} y={y - 2} width="4" height="4" fill="#fff4d5" style={{ animationDelay: `${-i * 1.3}s`, animationDuration: `${4 + i % 3}s` }} />
          ))}
          {Array.from({ length: 22 }, (_, i) => (
            <rect key={i} data-pixel-ripple="true" x={100 + (i * 139) % 900} y={568 + (i * 43) % 205} width={8 + i % 5 * 4} height="2" fill={i % 3 ? '#628ac1' : '#e9b877'} style={{ animationDelay: `${-i * .6}s`, animationDuration: `${4 + i % 3}s` }} />
          ))}
          {[0, 1, 2, 3, 4, 5].map(i => (
            <rect key={i} data-pixel-firefly="true" x={1080 + (i * 97) % 530} y={620 + (i * 53) % 240} width="4" height="4" fill="#ffe7a2" style={{ animationDelay: `${-i * 2.4}s`, animationDuration: `${9 + i}s` }} />
          ))}
        </g>
      </svg>
    </div>
  );
}

export default React.memo(FooterPixelScene);
